<template>
  <page-layout
    id="class-detail-page"
    title="class.class_detail"
    :name="classInfo.name"
    :navigateFunc="navigateFunc"
  >
    <div class="md-layout">
      <div class="md-layout-item">
        <isis-tabs class="classes-tabs">
          <template #content>
            <md-tab
              v-for="tab in tabs"
              :id="tab.name"
              :md-label="tab.label"
              :key="tab.name"
              @on-tab-change="onTabChanged"
              :md-template-data="tab.data"
              class="px-1"
            >
              <component
                :is="tab.component"
                :scoreData="scoreData"
                :classInfo="classInfo"
                :ref="tab.name"
                @editActivityData="setEditModalActivity($event)"
                @addActivityData="showActivityModal"
                @showImportXlsxFile="showImportXlsxFile"
              ></component>
            </md-tab>
          </template>
        </isis-tabs>

        <common-modal
          :name="assignStudentsModalProps.name"
          :title="assignStudentsModalProps.title"
          :primaryAction="assignStudentsModalProps.primaryAction"
          :secondaryActions="assignStudentsModalProps.secondaryActions"
          height="auto"
          width="1100px"
        >
          <template #modal-body>
            <student-selections
              :studentData="studentData"
              ref="studentSelectionsRef"
            ></student-selections>
          </template>
        </common-modal>

        <!-- add activity modal-->
        <add-activity-modal
          v-if="systemName"
          :name="addNewActivityModal.name"
          :title="addNewActivityModal.title"
          ref="activityModalAddSisRef"
        >
        </add-activity-modal>
        <!-- add activity LMS modal-->
        <add-activity-lms-modal
          v-if="systemName"
          :name="addNewActivityLmsModal.name"
          :title="addNewActivityLmsModal.title"
          ref="activityModalAddLmsRef"
        >
        </add-activity-lms-modal>

        <!-- edit activity modal sis-->
        <edit-activity-modal
          v-if="editActivityModal.isActiveModal"
          :name="editActivityModal.name"
          :title="editActivityModal.title"
          :dataDetail="editActivityModal.data"
          :defaultData="editActivityModal.defaultData"
          :score-list="editActivityModal.scoreList"
          ref="activityModalDetailRef"
        >
        </edit-activity-modal>

        <!-- Paramester modal Sis -->
        <parameter-modal-sis
          :name="parameterModalSis.name"
          :title="parameterModalSis.title"
          :score-data="scoreData"
        >
          <template #template-desc>
            <p class="template-desc">
              {{ $t("class.weight_for_each") }}
            </p>
          </template>
        </parameter-modal-sis>

        <!-- Parameter modal Lms -->
        <parameter-modal-lms
          :name="parameterModalLms.name"
          :title="parameterModalLms.title"
          ref="parameterLmsRefs"
        >
        </parameter-modal-lms>

        <!-- edit activity modal lms-->
        <edit-activity-lms-modal
          v-if="editActivityLmsModal.isActiveModal"
          :name="editActivityLmsModal.name"
          :title="editActivityLmsModal.title"
          :dataDetail="editActivityLmsModal.data"
          :defaultData="editActivityLmsModal.defaultData"
          :score-list="editActivityLmsModal.scoreList"
          ref="activityModalLmsDetailRef"
        >
        </edit-activity-lms-modal>

        <import-xlsx-modal
          :name="importXlsxScoreModalProps.name"
          :title="importXlsxScoreModalProps.title"
          :actions="importXlsxScoreModalProps.importXlsxModalActions"
        >
          <template #template-desc>
            <p class="template-desc">
              {{ $t("class.download_a") }}
              <a @click="downloadTemplate" class="cursor-pointer">{{
                $t("class.template")
              }}</a>
              {{ $t("common.see_an_example_of_the_format_required") }}
            </p>
          </template>
        </import-xlsx-modal>
        <import-xlsx-modal
          :name="importXlsxStudentEnrollModal.name"
          :title="importXlsxStudentEnrollModal.title"
          :actions="importXlsxStudentEnrollModal.action"
        >
          <template #template-desc>
            <p class="template-desc">
              {{ $t("common.download") }}
              <a @click="downloadCSVTemplate" class="cursor-pointer">
                {{ $t("smi_sri.xlsx_template") }}
              </a>
              {{ $t("common.see_an_example_of_the_format_required") }}
            </p>
          </template>
        </import-xlsx-modal>
        <div>
          <pdf-default ref="pdfContent" pdf-format="letter">
            <template #pdf-content>
              <ExportStudent
                v-if="showExport"
                :classInfo="classInfo"
                :studentList="studentList"
                :schoolInfo="info.school"
              ></ExportStudent>
            </template>
          </pdf-default>
        </div>
      </div>
    </div>
  </page-layout>
</template>

<script>
import PageLayout from "@/pages/PageLayout.vue";
import IsisTabs from "@/components/Base/IsisTabs";
import {
  StudentList,
  TeacherList,
  ScoreList,
  AttendanceList
} from "@/pages/Classes/Forms";
import StudentSelections from "../Forms/StudentList/StudentSelections.vue";
import { service_paths, service_names, cms_service_paths } from "@/constants/Services";
import { Message, initLoader, getId } from "@/helpers/utils";
import EditingInfo from "./EditingInfo.vue";
import { class_router_names } from "@/routes/routes";
import { postFileToS3, saveUploadedLink } from "@/helpers/aws-s3";
import AWSConst from "@/constants/AWS";
import ImportXlsxModal from "@/components/Base/ImportXlsxModal";
import ParameterModalSis from "../Forms/ScoreList/ScoreSis/ParameteModalSis.vue";
import ParameterModalLms from "../Forms/ScoreList/ScoreLms/ParameterModalLms.vue";
import Role from "@/constants/Role";
import { mapGetters } from "vuex";
import { hasValidRole } from "@/helpers/role-helper";
import EditActivityModal from "../Forms/ScoreList/ScoreSis/EditActivitySisModal.vue";
import cloneDeep from "lodash/cloneDeep";
import AddActivityModal from "../Forms/ScoreList/ScoreSis/AddActivityModal";
import ImportCsvModal from "@/components/Base/ImportCsvModal";
import EditActivityLmsModal from "../Forms/ScoreList/ScoreLms/EditActivityLmsModal";
import AddActivityLmsModal from "../Forms/ScoreList/ScoreLms/AddActivityLmsModal";
import ExportStudent from "../Forms/StudentList/ExportStudent";
import PdfDefault from "@/components/PdfDefault";
import {SYSTEM } from "@/constants/System";

export default {
  components: {
    AddActivityModal,
    EditActivityModal,
    ScoreList,
    PageLayout,
    IsisTabs,
    StudentSelections,
    ImportXlsxModal,
    ParameterModalSis,
    ParameterModalLms,
    ImportCsvModal,
    EditActivityLmsModal,
    AddActivityLmsModal,
    ExportStudent,
    PdfDefault
  },
  data() {
    const classId = this.$route.params.id;

    return {
      path: `${service_paths.classes}/${classId}`,
      pathGetCountStudentActive: `${service_names.school}/classes/${classId}/number-student`,
      pathClassActivity: `${service_paths.class_activities}/class/${classId}`,
      templatePath: `${service_paths.class_activities}/template/class/${classId}`,
      curTabName: "main-information",
      curTabRef: null,
      scoreData: {},
      tabs: [
        {
          name: "main-information",
          label: "class.main_information",
          component: EditingInfo
        },
        {
          name: "teacher-list",
          label: "class.teachers",
          component: TeacherList,
          data: {
            badge: ""
          }
        },
        {
          name: "student-list",
          label: "class.students",
          component: StudentList,
          data: {
            badge: ""
          }
        },
        {
          name: "scores-list",
          label: "class.scores",
          component: ScoreList
        },
        {
          name: "attendance-list",
          label: "student.attendance",
          component: AttendanceList
        }
      ],
      assignStudentsModalProps: {
        name: "assign-students-modal",
        title: "class.enroll",
        primaryAction: {
          title: "class.assign",
          action: this.assignStudents
        },
        secondaryActions: [
          {
            title: "common.cancel",
            action: () => {
              this.$modal.hide("assign-students-modal");
            }
          }
        ]
      },
      classId,
      studentData: [],
      classInfo: {},
      systemName: "",
      importXlsxScoreModalProps: {
        name: "import-classes-xlsx-modal",
        title: "class.import_scores_file_xlsx",
        importXlsxModalActions: {
          primary: {
            title: "common.upload_and_continue",
            action: this.uploadFileToS3
          }
        }
      },
      importXlsxStudentEnrollModal: {
        name: "import-student-enroll-modal",
        title: "class.import_student_enroll_xlsx",
        action: {
          primary: {
            title: "common.upload_and_continue",
            action: this.uploadFileXlsxToS3
          }
        },
        validationColumn: {
          validations: {
            student_id: {
              required: true,
              maxLength: 255
            }
          },
          fields: ["student_id"]
        }
      },
      parameterModalSis: {
        name: "parameter-modal-sis",
        title: "class.parameter"
      },
      parameterModalLms: {
        name: "parameter-modal-lms",
        title: "class.parameters_lms"
      },
      addNewActivityModal: {
        name: "add-activity-modal",
        title: "class.add_activity"
      },
      addNewActivityLmsModal: {
        name: "add-activity-modal-lms",
        title: "class.add_activity"
      },
      editActivityModal: {
        name: "edit-activity",
        title: "class.activity_detail",
        data: null,
        defaultData: null,
        isActiveModal: false,
        scoreList: null
      },
      editActivityLmsModal: {
        name: "edit-activity-lms-modal",
        title: "class.activity_detail",
        data: null,
        defaultData: null,
        isActiveModal: false,
        scoreList: null
      },
      showExport: false,
      studentList: ""
    };
  },

  created() {
    this.getClassInfo();
  },
  computed: {
    ...mapGetters("user", ["role", "info"]),
    isDisableScoreAction() {
      return this.scoreData?.score_lists?.length > 0;
    }
  },
  methods: {
    exportStudent(studentList) {
      this.studentList = studentList;
      this.showExport = true;
      this.$refs.pdfContent.generatePdf();
    },
    showImportXlsxFile() {
      this.$modal.show("import-student-enroll-modal");
    },
    async uploadFileXlsxToS3(file) {
      let loader = initLoader();
      const s3FolderPath = AWSConst.S3_IMPORT_ENROLL_STUDENT_PATH;
      try {
        const savedLink = await postFileToS3(s3FolderPath, file);
        await saveUploadedLink(
          savedLink,
          `${service_paths.classes}/${this.classId}/import/enroll-student`
        );
        this.$modal.hide("import-student-enroll-modal");
        Message.success(
          this.$t("student.your_request_is_waiting_for_approval")
        );
      } finally {
        loader.hide();
      }
    },
    setEditModalActivity(e) {
      this.editActivityModal.data = e;
      this.editActivityModal.defaultData = cloneDeep(e);
      this.editActivityModal.isActiveModal = true;
      this.editActivityModal.scoreList = this.scoreData.score_lists;
      if (this.$refs.activityModalDetailRef) {
        this.$refs.activityModalDetailRef.getParameters();
        this.$refs.activityModalDetailRef.closeCardConfirmDelete();
      }
      this.$nextTick(() => {
        this.$modal.show("edit-activity");
      });
    },
    showActivityModal() {
      this.systemName = this.classInfo.lms.name;

      this.$nextTick(() => {
        if (this.systemName === SYSTEM.SIS) {
          this.$refs.activityModalAddSisRef.initData();
          this.$modal.show(this.addNewActivityModal.name);
          return;
        } else if (
          this.systemName === SYSTEM.EDMENTUM ||
          this.systemName === SYSTEM.AGILIX
        ) {
          this.$refs.activityModalAddLmsRef.initData();
          this.$modal.show(this.addNewActivityLmsModal.name);
        }
      });
    },
    //modal lms
    setEditActivityLmsModal(activity) {
      this.editActivityLmsModal.data = activity;
      this.editActivityLmsModal.defaultData = cloneDeep(activity);
      this.editActivityLmsModal.scoreList = this.scoreData.score_lists;
      this.editActivityLmsModal.isActiveModal = true;
      if (this.$refs.activityModalLmsDetailRef) {
        this.$refs.activityModalLmsDetailRef.closeCardConfirmDelete();
      }
      this.$nextTick(() => {
        this.$modal.show(this.editActivityLmsModal.name);
      });
    },
    getClassInfo(status = "") {
      this.$axios.get(`${this.path}`).then(({ data }) => {
        this.classInfo = data;

        this.getScores();
        this.tabs[1].data.badge = data.teachers.length;
        this.tabs.forEach(tab => {
          if (status != "update_teacher_list" || this.classInfo.lms.name != SYSTEM.LMS)
            this.$refs[tab.name][0].injectFormData(data);
        });
      });
    },

    async getNumberAssignStudent() {
      await this.$refs["student-list"][0].updateStudentTable();
      const { data: totalStudentActive } = await this.$axios.get(
        this.pathGetCountStudentActive
      );
      this.tabs[2].data.badge = +totalStudentActive;
    },

    onTabChanged(tabId) {
      this.curTabName = tabId;
      this.curTabRef = this.$refs[tabId];
    },

    async openAssignmentModal() {
      this.$modal.show(this.assignStudentsModalProps.name);
    },

    openScoreModal(type) {
      if (type === "parameter-lms") {
        this.$refs.parameterLmsRefs.setMode(this.classInfo);
        this.$refs.parameterLmsRefs.closeCardConfirmDelete();
        this.$refs.parameterLmsRefs.getParameters();
        return this.$modal.show(this.parameterModalLms.name);
      }
      if (type === "parameter")
        return this.$modal.show(this.parameterModalSis.name);
      return this.$modal.show(this.importXlsxScoreModalProps.name);
    },

    assignStudents() {
      const selectedUsernames = this.$refs.studentSelectionsRef.getSelected();

      this.$axios
        .post(`${this.path}/assign-students`, {
          usernames: selectedUsernames
        })
        .then(async ({ data }) => {
          Message.success(this.$t("class.assign_students_successfully"));
          this.$modal.hide(this.assignStudentsModalProps.name);
          await this.getNumberAssignStudent();
          if (this.classInfo.lms.name == SYSTEM.LMS) {
            let params = data.map(x => {
              return {
                ...x,
                id_ref: x.id,
                class_id_ref: x.class_id,
                student_id_ref: x.user_id
              }
            })
            await this.$axios.cms_post(`${cms_service_paths.assign_students}`, params, {}, {}, null, false)
          }

        });
    },

    navigateFunc() {
      this.$router.push({
        name: class_router_names.listPage
      });
    },

    async uploadFileToS3(file) {
      const loader = initLoader();

      const s3FolderPath = AWSConst.S3_IMPORT_SCORE_PATH;

      try {
        const savedLink = await postFileToS3(s3FolderPath, file);

        await saveUploadedLink(
          savedLink,
          `${service_paths.class_activities}/import/class/${this.classId}`
        );

        this.$modal.hide(this.importXlsxScoreModalProps.name);

        Message.success(this.$t("class.your_request_is_waiting_for_approval"));
      } catch (error) {
        console.log(error);
      } finally {
        loader.hide();
      }
    },

    getScores(paramsPassed = {}) {
      let params = { ...paramsPassed };
      if (hasValidRole(this.role, Role.Student)) {
        params.student_id = getId(this.info);
      }
      if (hasValidRole(this.role, Role.Family)) {
        params.student_id = this.info.children_id;
      }
      const systemName = this.classInfo?.lms?.name;
      if (systemName === SYSTEM.SIS) {
        return this.$axios
          .get(this.pathClassActivity, params)
          .then(response => {
            if (response.data) {
              this.scoreData = response.data;
              this.scoreData.systemName = systemName;
            }
          });
      }
      //extra coursework
      else {
        return this.$axios
          .get(
            `${service_names.school}/class-activities/lms/class/${this.classId}`,
            params
          )
          .then(response => {
            if (response.data) {
              this.scoreData = response.data;
              this.scoreData.systemName = systemName;
            }
          });
      }
    },

    downloadTemplate() {
      this.$axios
        .get(this.templatePath, {}, true, {}, "blob")
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "template.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    downloadCSVTemplate() {
      this.$axios
        .get(
          `${service_paths.classes}/template/enroll-student`,
          {},
          true,
          {},
          "blob"
        )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "student_enroll_class_template.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    }
  },

  mounted() {
    this.curTabRef = this.$refs[this.curTabName];
    if (hasValidRole(this.role, [Role.Student, Role.Family])) {
      this.tabs = this.tabs.filter(el => el.name !== "student-list");
    } else {
      this.getNumberAssignStudent();
    }
  },

  provide() {
    return {
      openAssignmentModal: this.openAssignmentModal,
      getClassInfo: this.getClassInfo,
      getNumberAssignStudent: this.getNumberAssignStudent,
      openScoreModal: this.openScoreModal,
      getScores: this.getScores,
      setEditActivityLmsModal: this.setEditActivityLmsModal,
      exportStudent: this.exportStudent
    };
  }
};
</script>

<style lang="scss">
.isis-tabs.classes-tabs {
  .md-content.md-tabs-content.md-theme-default {
    height: auto !important;
  }
}
</style>
